<!-- 
CreditCardValidationDataTable.vue
功能：信用卡身分驗證異常名單 DataTable
作者：i9400538 陳博承
完成：2022-04-26
-->
<template>
  <section class="newTable">
    <table
      class="table datatable table-striped area-list-datatable"
      id="CreditCardValidationDataTable"
    >
      <thead>
        <tr>
          <th id="th_sel" width="120">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th id="th_apc_name">要保人</th>
          <th
            id="th_apc_id"
            :class="'sorting ' + (order.fieldName == 'apc_id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('apc_id')"
          >要保人ID</th>
          <th
            id="th_auth_no"
            :class="'sorting ' + (order.fieldName == 'auth_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('auth_no')"
          >授權書編號</th>
          <th id="th_bank_name">扣款銀行</th>
          <th id="th_auth_name">授權人</th>
          <th id="th_detail" ref="lastCol">明細查詢</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr
          v-for="(d, did) in tableDataBackup"
          :key="`CreditCardValidationDataTable-table-td-${did}`"
        >
          <td width="120">
            <div class="min-h-30">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`CreditCardValidationDataTable-check-${did}`"
                  :value="d.apc_id"
                  v-model="selection"
                  :disabled="d.apc_id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`CreditCardValidationDataTable-check-${did}`"></label>
              </div>
              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td>
            <Tooltip
              :position="did < 3 ? 'bottom' : 'top'"
              expand_col1="要保人"
              :expand_col1_value="d.apc_name"
              expand_col2="要保人ID"
              :expand_col2_value="d.apc_id"
              expand_col3="授權人"
              :expand_col3_value="d.auth_name"
            >
              <a
                v-if="d.is_exist"
                class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.apc_id, d.apc_name)"
              >{{d.apc_name | getMaskName}}</a>
              <a v-else>{{d.apc_name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td>{{d.apc_id | getMaskID}}</td>
          <td>{{d.auth_no}}</td>
          <td>{{d.bank_name}}</td>
          <td>{{d.auth_name | getMaskName}}</td>
          <!--明細查詢-->
          <td :width="iPadWidth">
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('detail-modal-open', d)"
            >明細查詢</button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="7" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "CreditCardValidationDataTable",
  mixins: [commonMixin],
  components: { Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "apc_id",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      is_iPad: is_iPad,
      iPadWidth: 182
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      this.tableDataBackup = [];
      setTimeout(() => {
        this.tableDataBackup = [...this.tableData];
        this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName));
        this.registerHanlink(); // for 難字更新
      }, 20);
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.apc_id;
      });
      this.order.fieldName = "apc_id";
      this.order.asc = false;
      this.columnSorting("apc_id");

      if (!is_iPad && this.UserInfo.userType !== "box") {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.min-h-30 {
  min-height: 30px;
}
.a-disabled {
  color: gray;
}
</style>
